// Event Names are defined as constants.
export const CHECKLIST_IMPRESSION = 'Organizer Checklist Impression';
export const ITEM_INTERACTION = 'Organizer Item Interaction';
export const NAVIGATE = 'Navigate Organizer';
export const NAVIGATE_VENDOR_MANAGER = 'Navigate Vendor Manager';
export const ORGANIZER_BATCH_TASKS_UPDATE = 'Organizer Batch Tasks Update';
export const ORGANIZER_PROMPT_DISPLAYED = 'Organizer Prompt Displayed';
export const QUESTION_ANSWERED = 'Organizer Question Answered';
export const SEARCH_ORGANIZER = 'Search Organizer';
export const UPDATE_ORGANIZER_VIEW = 'Update Organizer View';
export const WEDDING_DETAILS_INTERACTION = 'Wedding Details Interaction';
export const WIDGET_VIEWED = 'Widget Viewed';
export const BUDGETER_IMPRESSION = 'Organizer Budgeter Impression';
export const BUDGETER_INTERACTION = 'Budgeter Interaction';
export const BUDGETER_CUSTOMIZATION_VIEWED = 'Viewed wedding budgeter - customization';
export const BUDGETER_MAP_VIEWED = 'Viewed wedding budgeter - map';
export const CLICK_THROUGH_VENDOR = 'Click-through to Vendor';
export const VENDOR_TILE_VIEWED = 'Vendor Tile Viewed';
export const VENDOR_MARKED_BOOKED = 'Vendor Marked as Booked';

// Constant Event Properties.
export const SOURCE_CHECKLIST = 'checklist';
